import { QUERY_POLICY } from '../../constants/actions/policy';

export function queryPolicy(payload) {
    return {
        type: QUERY_POLICY,
        payload,
    };
}
